/* Base bundle for all frontend pages.  Imported by the base.html template. */

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "font-awesome/css/font-awesome.min.css"
import { select, selectAll } from "d3-selection"

/* Polyfills */
import "core-js"
import "regenerator-runtime/runtime"

import "../../css/frontend.css"
import "../../css/operator-action.css"
import GenerateNavOptions from "../components/navbar/GenerateNavOptions"

$(document).ready(function () {
  const toggle_navbar = select("#toggle-navbar")
  const expandNavOption = selectAll(".expand-nav-option")
  const sidebar = select(".sidebar")
  const toggle_navbar_glyph = select("#toggle-navbar-glyph")
  const main = select(".main")

  main.on("click", function () {
    const classList = toggle_navbar_glyph.attr("class")

    if (classList.includes("fa-chevron-left")) {
      hideNavbar(toggle_navbar_glyph, sidebar, toggle_navbar)
    }
  })

  toggle_navbar.on("click", function () {
    const classList = toggle_navbar_glyph.attr("class")

    if (classList.includes("fa-chevron-left")) {
      hideNavbar(toggle_navbar_glyph, sidebar, toggle_navbar)
    } else {
      GenerateNavOptions()
      showNavbar(toggle_navbar_glyph, sidebar, toggle_navbar)
    }
  })

  expandNavOption.on("click", function () {
    const classList = toggle_navbar_glyph.attr("class")

    if (classList.includes("fa-chevron-right")) {
      showNavbar(toggle_navbar_glyph, sidebar, toggle_navbar)
    }
  })

  $("#navbar-toggler-icon-button").on("click", function () {
    GenerateNavOptions()
  })
})

const showNavbar = (toggle_navbar_glyph, sidebar, toggle_navbar) => {
  toggle_navbar_glyph.attr("class", "fa fa-chevron-left")
  sidebar.style("margin-left", "var(--navbar-showing-margin)")
  toggle_navbar.style("margin-left", "var(--navbar-total-width)")
}

const hideNavbar = (toggle_navbar_glyph, sidebar, toggle_navbar) => {
  toggle_navbar_glyph.attr("class", "fa fa-chevron-right")
  sidebar.style("margin-left", "var(--navbar-hidden-margin)")
  toggle_navbar.style("margin-left", "var(--navbar-showing-width)")
}
